module.exports = __webpack_public_path__ + "img/AnimodGiftbox.26ffc7b.webp";